export function useDialogSurfaceContextValues_unstable(state) {
  const dialogSurface = true;
  return {
    dialogSurface
  };
}
//# sourceMappingURL=useDialogSurfaceContextValues.js.map